import { FC, memo } from 'react'

import { ScheduleGroupMonthly } from './components/scheduleGroupMonthly/scheduleGroupMonthly'
import { ScheduleMonthly } from './components/scheduleMonthly/scheduleMonthly'
import { ScheduleWeekly } from './components/scheduleWeekly/scheduleWeekly'
import { Navigate, Route, Routes } from 'react-router-dom'
import { CrewErrorBoundary } from 'components/functions/crewErrorBoundary'
import { ScheduleToolbar } from './components/scheduleToolbar/scheduleToolbar'
import { EventTimePeriod, SettingKeyType } from '@crew/enums/app'
import { useUserSetting } from '@crew/states'

export const SchedulePage: FC = memo(() => {
  const defaultScheduleInitialDisplay = useUserSetting(
    SettingKeyType.ScheduleInitialDisplay,
    EventTimePeriod.GroupMonthly.value
  )

  return (
    <div className="flex flex-col gap-2.5 p-2.5 h-full overflow-hidden">
      <CrewErrorBoundary>
        <ScheduleToolbar />
      </CrewErrorBoundary>

      <CrewErrorBoundary>
        {/* URLに応じて表示するコンポーネントを切り替える */}
        <Routes>
          {/** Show default schedule screen when accessing the root (/) */}
          <Route
            index
            element={
              <Navigate
                to={defaultScheduleInitialDisplay as string}
                replace={true}
              />
            }
          />
          <Route
            path={EventTimePeriod.GroupMonthly.value}
            element={<ScheduleGroupMonthly />}
          />
          <Route
            path={EventTimePeriod.Monthly.value}
            element={<ScheduleMonthly />}
          />
          <Route
            path={EventTimePeriod.Weekly.value}
            element={<ScheduleWeekly />}
          />
        </Routes>
      </CrewErrorBoundary>
    </div>
  )
})
